function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4002 2.40002H18.2002V0H15.8002V2.40002H6.20021V0H3.80019V2.40002H2.60021C1.27423 2.40002 0.212233 3.474 0.212233 4.80003L0.200195 21.6C0.200195 22.926 1.27418 24 2.60021 24H19.4002C20.7262 24 21.8002 22.926 21.8002 21.6V4.79998C21.8002 3.474 20.7262 2.40002 19.4002 2.40002ZM19.4002 21.6H2.60021V8.39997H19.4002V21.6Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4362 12.0728L15.1642 10.8008L9.30818 16.6568L6.76422 14.1128L5.49219 15.3848L9.30818 19.2008L16.4362 12.0728Z",
  fill: "black"
});

var SvgEvent = function SvgEvent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEvent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/event.0c905d4d.svg";
export { ForwardRef as ReactComponent };